"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = _interopRequireDefault(require(".."));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var _concat = function _concat(a, b) {
  return a.concat(b);
};

var _flattenChild = function _flattenChild(c) {
  if (Array.isArray(c)) {
    return c.reduce(_concat, []).map(_flattenChild);
  }

  return c;
};

var _isGroupCondition = function _isGroupCondition(child) {
  return child.type && child.type.isGroupCondition;
};

var Group = function Group(_ref) {
  var children = _ref.children;
  var conditionals = children.map(_flattenChild).reduce(function (x, y) {
    return x.concat(y);
  }, []).filter(function (c) {
    return c.type === _.default;
  });
  var matchedConditionals = conditionals.filter(function (c) {
    return _.default.test(c);
  });
  return _react.default.createElement(_react.Fragment, null, children.filter(function (c) {
    return !_isGroupCondition(c) || c.type.test(c.props, matchedConditionals.length, conditionals.length);
  }));
};

Group.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = Group;
exports.default = _default;